<template>
  <div class="bg-body rounded p-5 pb-3 mb-5">
    <div class="d-flex align-items-center mb-3">
      <h4 class="align-items-start flex-column fw-bold text-gray-900 m-0 ms-2">
        {{ this.$route.meta.title || 'Страница' }}
        <span class="text-muted fw-normal fs-6">- Абонементы</span>
      </h4>
      <slot name="create"></slot>
    </div>
    <div class="btn-custom-white d-flex ms-1 mb-2" role="group">
      <button type="button" @click="goToPage('TicketList')" :class="this.$route.name === 'TicketList' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Управление абонементами</button>
      <button type="button" @click="goToPage('TicketSale')" :class="this.$route.name === 'TicketSale' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Управление витриной</button>
      <button type="button" @click="openGrantModal" class="btn btn-light-success btn-sm me-2 mb-2">Начислить абонемент</button>
    </div>
  </div>
  <ticket-grant-modal v-if="showGrantModal" @closeModal="closeGrantModal"/>
</template>

<script>
import TicketGrantModal from '@/views/EnergoGoClub/Tickets/TicketGrantModal'
export default {
  components: { TicketGrantModal },
  name: 'TicketsHeaderList',
  data() {
    return {
      showGrantModal: false,
    }
  },
  methods: {
    goToPage(page) {
      this.$router.push({ name: page });
    },
    closeGrantModal() {
      this.showGrantModal = false;
    },
    openGrantModal() {
      this.showGrantModal = true;
      setTimeout(() => {
        const modalEl = document.getElementById('ticketGrantModal');
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }, 10);
    },
  },
}
</script>

<style scoped>

</style>